module.exports = __webpack_public_path__ + "img/watchLive.4fe39cd5.svg";